// Icons
import { IconPackageExport } from '@tabler/icons-react'

// Mantine
import { Button, Modal, ActionIcon, Tooltip, NumberInput } from '@mantine/core'

// React
import { useState, useEffect } from 'react'

// Axios API
import { useAxiosApi } from '../../hooks/useAxiosApi'

// UI
import SKU from '../ui/SKU'

export default function PurchaseOrderIncoming({ line, refetch }) {
    //Modal state
    const [opened, setOpened] = useState(false)

    //Received quantity state
    const [receivedQuantity, setReceivedQuantity] = useState(1)

    // Modal actions
    const openModal = () => {
        setOpened(true)
        setReceivedQuantity(1)
    }

    const closeModal = () => setOpened(false)

    // Calculations
    const quantityStillToReceive =
        line.quantity_to_receive - line.quantity_received

    // Mark component as received
    const { requestPost } = useAxiosApi()

    const [isSubmitting, setIsSubmitting] = useState(false)

    const markComponentAsReceived = async () => {
        setIsSubmitting(true)

        await requestPost(`/purchase-orders/received/${line.id}`, {
            quantity: receivedQuantity,
        })

        await refetch()

        setIsSubmitting(false)
        closeModal()
    }

    return (
        <>
            <Tooltip label="Enregistrer une arrivée de composants">
                <ActionIcon onClick={openModal} variant="default" size="lg">
                    <IconPackageExport size="1rem" />
                </ActionIcon>
            </Tooltip>

            <Modal
                opened={opened}
                title="Enregistrer une arrivée de composants"
                onClose={closeModal}
            >
                <div className="flex flex-col gap-5">
                    <div className="flex flex-col items-start">
                        <span className="font-medium">
                            {line.component.component_category.name_fr}
                            {' – '}
                            {line.component.name}
                        </span>

                        <SKU component={line.component} size="sm" />
                    </div>

                    <div className="flex flex-col gap-2">
                        <NumberInput
                            label="Quantité reçue"
                            min={1}
                            clampBehavior="strict"
                            allowDecimal={false}
                            value={receivedQuantity}
                            onChange={(value) => setReceivedQuantity(value)}
                        />

                        {quantityStillToReceive > 0 && (
                            <span className="text-xs text-gray-400">
                                {quantityStillToReceive} composant(s) restant(s)
                                à recevoir à cette date
                            </span>
                        )}

                        {quantityStillToReceive <= 0 && (
                            <span className="text-xs text-green-400">
                                Tous les composants ont été reçus
                            </span>
                        )}
                    </div>

                    <div className="flex grid grid-cols-2 gap-3">
                        <Button variant="default" onClick={closeModal}>
                            Annuler
                        </Button>

                        <Button
                            loading={isSubmitting}
                            onClick={markComponentAsReceived}
                        >
                            Enregistrer
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    )
}
